import React from 'react';
import PropTypes from 'prop-types';

import Title from '../components/title';
import Chevron from '../components/chevron';

const ExternalMenu = (props) => (
    <ul className="page__menu page__menu--external">
        {props.items.map((item, i) => {
            const itemUrl = item.url;
            let isCurrentPage = window.location.href == itemUrl ? true : false;

            return (
                <Title
                    key={i}
                    level={4}
                    tag="li"
                    className={`
                        page__menu__item
                        ${
                            item.current || isCurrentPage
                                ? 'page__menu__item--current'
                                : ''
                        }
                    `}>
                    {((item.current || isCurrentPage) && (
                        <span title={item.text}>
                            <span
                                dangerouslySetInnerHTML={{ __html: item.text }}
                            />
                        </span>
                    )) || (
                        <a
                            href={item.url}
                            title={item.text}
                            target={item.target ? '_blank' : '_self'}>
                            <span
                                dangerouslySetInnerHTML={{ __html: item.text }}
                            />
                            <Chevron tag="span" />
                        </a>
                    )}
                </Title>
            );
        })}
    </ul>
);

ExternalMenu.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            text: PropTypes.string.isRequired,
            url: PropTypes.string.isRequired,
            target: PropTypes.bool.isRequired,
        }),
    ),
};

export default ExternalMenu;
